export default __webpack_public_path__ + "static/cpc-ae783422430fcdfb910c54bb28218b4c.png";